import APIClient from '@/shared/http/clients/api'

const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const resourceName = 'MidiaDespesa'

const GetByDespesaId = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByDespesaId/${id}`, config)
const Base64ByArquivoId = (arquivoId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/DownloadZpagConprovante/${arquivoId}`, data, config)

const TravelExpenseRepository = {
  GetByDespesaId,
  Base64ByArquivoId
}

export default TravelExpenseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/midiaexpense.js